
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Sun, Zap, BatteryCharging, WifiOff } from "lucide-react";
import { SistemaConfig } from "@/types";

// Export the SistemaBase type to be used in other files
export interface SistemaBase {
  nome: string;
  descricao?: string;
  valorPorKwp: number;
  eficiencia: number;
  perdas: number;
  fatorSimultaneidade: number;
  fatorCapacidade: number;
  marcaPadraoPainel?: string;
  modeloPadraoPainel?: string;
  fotoPadraoPainel?: string;
  marcaPadraoInversor?: string;
  modeloPadraoInversor?: string;
  fotoPadraoInversor?: string;
}

interface SystemTypeSelectorProps {
  tipoSistema: string;
  sistemasConfig: Record<string, SistemaBase>;
  onChangeTipoSistema: (value: string) => void;
}

export const SystemTypeSelector = ({
  tipoSistema,
  sistemasConfig,
  onChangeTipoSistema,
}: SystemTypeSelectorProps) => {
  const getIconForSistema = (tipo: string) => {
    switch (tipo) {
      case "mlpe": return <Zap className="h-5 w-5" />;
      case "hibrido": return <BatteryCharging className="h-5 w-5" />;
      case "offgrid": return <WifiOff className="h-5 w-5" />;
      default: return <Sun className="h-5 w-5" />;
    }
  };

  return (
    <Card className="mt-6">
      <CardHeader>
        <div className="flex justify-between items-center">
          <div>
            <CardTitle>Tipo de Sistema Solar</CardTitle>
            <CardDescription>
              Selecione o tipo de sistema fotovoltaico para dimensionamento
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <RadioGroup 
          value={tipoSistema} 
          onValueChange={onChangeTipoSistema}
          className="grid grid-cols-1 md:grid-cols-4 gap-4"
        >
          {Object.entries(sistemasConfig).map(([tipo, config]) => (
            <div key={tipo} className={`border rounded-lg p-4 cursor-pointer transition-all ${tipoSistema === tipo ? 'border-green-500 bg-green-50' : 'border-gray-200 hover:border-green-300'}`}>
              <RadioGroupItem value={tipo} id={`sistema-${tipo}`} className="sr-only" />
              <Label htmlFor={`sistema-${tipo}`} className="flex flex-col items-center gap-2 cursor-pointer">
                <div className={`rounded-full p-3 ${tipoSistema === tipo ? 'bg-green-500 text-white' : 'bg-gray-100'}`}>
                  {getIconForSistema(tipo)}
                </div>
                <span className="font-semibold">{config.nome}</span>
                <span className="text-sm text-center text-gray-500">{config.descricao?.length > 60 ? `${config.descricao.substring(0, 60)}...` : config.descricao}</span>
                <span className="font-semibold text-green-600">
                  {config.valorPorKwp.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}/kWp
                </span>
              </Label>
            </div>
          ))}
        </RadioGroup>
      </CardContent>
    </Card>
  );
};
